import { get } from "@/utils/request"; // 导入模块

// 首页名企招聘
export const getClientList = (params) =>
  get("Api/Index/GetIndexClientList", params);

// 首页最新职位
export const getNewJobList = (params) =>
  get("Api/Index/GetIndexJobList", params);

// 首页应届
export const getReigningList = (params) =>
  get("Api/Index/GetIndexJobListForRecruitmentType1", params);

// 首页实习
export const getInternshipList = (params) =>
  get("Api/Index/GetIndexJobListForRecruitmentType2", params);





// // 首页名企招聘
// export const getClientList = (params) =>
//   get("api/Api/Index/GetIndexClientList", params);

// // 首页最新职位
// export const getNewJobList = (params) =>
//   get("api/Api/Index/GetIndexJobList", params);

// // 首页应届
// export const getReigningList = (params) =>
//   get("api/Api/Index/GetIndexJobListForRecruitmentType1", params);

// // 首页实习
// export const getInternshipList = (params) =>
//   get("api/Api/Index/GetIndexJobListForRecruitmentType2", params);
